import { render } from "./ContactPerson.vue?vue&type=template&id=5b1e23b2"
import script from "./ContactPerson.vue?vue&type=script&lang=js"
export * from "./ContactPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__